import { createSelector } from '@ngrx/store';
import { selectErrorState } from '../reducers';

export const selectIsIdPError = createSelector(
  selectErrorState,
  (errorState) =>
    errorState.errorType === 'IDP' || errorState.errorType === 'MFA',
);

export const selectErrorInfo = createSelector(
  selectErrorState,
  (errorState) => {
    return errorState.errorInfo ?? null;
  },
);
